module.exports = __webpack_public_path__ + "static/media/plus-black-icon.fbcff910.svg";